import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Footer from '@common/footer';
import Content from '@common/content';
import NudgeWrapper from '@common/nudges/nudgeWrapper';
import { AccTutorialCustomHead } from '@common/customHead';
import Tutorial from '@components/acc/tutorial';

/** 구 역검 튜토리얼 페이지 입니다.
 * 잡다 내 집입 점은 없지만, 사이트 검색으로 유입되는 페이지 입니다
 * */
const TutorialPage = () => {
  return (
    <Layout>
      <AccTutorialCustomHead />
      <NudgeWrapper>
        <Header />
        <Content>
          <Tutorial />
        </Content>
      </NudgeWrapper>
      <Footer />
    </Layout>
  );
};

export default TutorialPage;
